function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  left: 42px;\n  bottom: ",
        ";\n  z-index: 99999;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  color: ",
        ";\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  transition: box-shadow 0.15s ease;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n\n  font-size: 11px;\n  font-weight: bold;\n\n  &:hover {\n    box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import { useWrContext } from "../../wr-context";
export var PreProdButton = function() {
    var ref, ref1, ref2;
    var context = useWrContext();
    var userId = ((ref = context.state.user) === null || ref === void 0 ? void 0 : ref.externalId) || ((ref1 = context.state.user) === null || ref1 === void 0 ? void 0 : ref1.id) || ((ref2 = context.state.user) === null || ref2 === void 0 ? void 0 : ref2.email);
    var ref3 = context.constants.preProd || {}, button = ref3.button, _isInPreProdMode = ref3.isInPreProdMode, isInPreProdMode = _isInPreProdMode === void 0 ? false : _isInPreProdMode, _strategy = ref3.strategy, strategy = _strategy === void 0 ? "Default" : _strategy, domain = ref3.domain, allowedUsers = ref3.allowedUsers;
    var Component = button === null || button === void 0 ? void 0 : button.Component;
    var strategiesMap = {
        LocalStorage: {
            enter: function() {
                localStorage.setItem(isPreProdKey, "true");
                window.location.reload();
            },
            exit: function() {
                localStorage.removeItem(isPreProdKey);
                window.location.reload();
            }
        },
        Default: {
            enter: function() {
                var ref;
                if (!domain) throw new Error("Domain is required for the pre-prod button");
                (ref = window.open(domain)) === null || ref === void 0 ? void 0 : ref.focus();
            },
            exit: function() {
                window.close();
            }
        }
    };
    var handleClick = function() {
        var strategyFuncs = strategiesMap[strategy];
        if (isInPreProdMode) {
            return strategyFuncs.exit();
        }
        strategyFuncs.enter();
    };
    var isUserAllowedInPreProd = allowedUsers === "all" || (allowedUsers === null || allowedUsers === void 0 ? void 0 : allowedUsers.some(function(user) {
        return user === userId;
    }));
    if (!isUserAllowedInPreProd && !isInPreProdMode) return null;
    return /*#__PURE__*/ React.createElement(ButtonContainer, {
        isInPreProdMode: isInPreProdMode
    }, Component ? /*#__PURE__*/ React.createElement(Component, {
        handleClick: handleClick,
        isInPreProdMode: isInPreProdMode
    }) : /*#__PURE__*/ React.createElement(Button, {
        type: "button",
        onClick: handleClick
    }, isInPreProdMode && /*#__PURE__*/ React.createElement(React.Fragment, null, "EXIT"), !isInPreProdMode && /*#__PURE__*/ React.createElement(React.Fragment, null, "PRE ", /*#__PURE__*/ React.createElement("br", null), " PROD")));
};
export var isPreProdKey = "wr_is_pre_prod";
var ButtonContainer = styled.div(_templateObject(), function(props) {
    return props.isInPreProdMode ? "74px" : "42px";
});
var Button = styled.button(_templateObject1(), function(props) {
    return props.theme.palette.primary;
}, function(props) {
    return props.theme.palette.background;
});
